"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ArrowIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
// Packages

// Main Component
function ArrowIcon({
  icon,
  color,
  width,
  height,
  title
}) {
  switch (icon) {
    default:
    case "left":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Left Arrow"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.5 9H4.5",
        stroke: color,
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.875 5.625L4.5 9L7.875 12.375",
        stroke: color,
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "right":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Right Arrow"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4.5 9H13.5",
        stroke: color,
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.125 5.625L13.5 9L10.125 12.375",
        stroke: color,
        strokeWidth: "0.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "up":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height || 19,
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Up Arrow"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9 13.7012V4.70117",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.625 8.07617L9 4.70117L12.375 8.07617",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
  }
}
ArrowIcon.propTypes = {
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets color of icon
   */
  color: _propTypes.default.string,
  /**
   * Sets width of icon
   */
  width: _propTypes.default.number,
  /**
   * Sets height of icon
   */
  height: _propTypes.default.number,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string
};
ArrowIcon.defaultProps = {
  color: "#1a202c",
  // Orca Grey 8
  height: 18,
  width: 18
};
ArrowIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowIcon",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"#1a202c\"",
        "computed": false
      },
      "description": "Sets color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "18",
        "computed": false
      },
      "description": "Sets height of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "18",
        "computed": false
      },
      "description": "Sets width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};